import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { useState, useEffect, useRef } from "react";

import { revisionCards } from './data/revisionCards';
import { pastelColors } from './data/pastelColors';

const RevisionCard = ({ card, index }: { card: typeof revisionCards[0], index: number }) => {
  const color = pastelColors[index % pastelColors.length];
  return (
    <div className="w-[300px] h-[360px] rounded-xl shadow-md p-6 flex flex-col justify-center items-center text-center transform transition-all duration-300 hover:scale-[1.02]">
      <div className="absolute inset-0 bg-gradient-to-br" style={{
        background: color,
        mixBlendMode: 'multiply'
      }} />
      
      <div className="absolute top-4 left-4 right-4 z-10">
        <h3 className="text-lg font-cursive text-gray-700 whitespace-pre-wrap px-4 py-2 bg-white/50 rounded-lg text-center shadow-sm">
          {card.topText}
        </h3>
      </div>

      <div className="absolute top-1/4 bottom-0 left-4 right-4 z-10 p-4">
        <p className="font-sans text-base text-neutral-700 leading-relaxed text-center">
          <span dangerouslySetInnerHTML={{ __html: card.bottomText }} />
        </p>
      </div>
    </div>
  );
};

export const AboutIQify = () => {
  return (
    <div className="w-full max-w-7xl mx-auto px-6 py-12">
      <div className="flex flex-col lg:flex-row items-center gap-8">
        {/* About Text Section */}
        <div className="lg:w-1/2 text-center lg:text-left">
          <h2 className="text-4xl font-bold mb-4">About IQify</h2>
          <p className="text-lg text-gray-700 mb-6">
            IQify is dedicated to unlocking your full cognitive potential through scientifically proven methods. Our global approach has empowered students across the globe to achieve exceptional academic success. Explore how our approach can bridge the gap between potential and achievement.
          </p>
          <a href="/about" className="text-blue-500 hover:underline inline-flex items-center gap-2">
            <span>Learn More</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>

        {/* Carousel Section */}
        <div className="lg:w-1/2">
          <Swiper
            modules={[Navigation]}
            navigation
            loop={true}
            centeredSlides={true}
            slidesPerView={'auto'}
            spaceBetween={32}
            speed={500}
            className="w-full"
          >
            {revisionCards.map((card, index) => (
              <SwiperSlide key={card.id} className="w-[300px] h-[380px]">
                <RevisionCard card={card} index={index} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};
